export class ChannelHelper {
    getChannel(): string {
        return 'INTERNET';
    }
}

export const channelHelper = new ChannelHelper();